// extracted by mini-css-extract-plugin
export default {"root":"Checkbox__root--1YIa3","selected":"Checkbox__selected--3HV2v","disabled":"Checkbox__disabled--2Z_84"};